import { useFormik } from "formik";
import { adminUpdateStatusShift } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";

const StatusModalShift = ({ show, onCloseClick, getData, data }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      isActive: data?.isActive ?? "",
    },
    validationSchema: Yup.object({
      isActive: Yup.mixed()
        .oneOf([true, false], "Status harus diisi!")
        .required("Status harus diisi!"),
    }),
    onSubmit: (values) => {
      adminUpdateStatusShift(data._id, values)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Status <b>{response?.name}</b> berhasil diubah!
            </div>
          );
          validation.resetForm();
        })
        .catch(() => {
          toast.error("Gagal mengubah status shift!");
        });
    },
  });

  const comboType = [
    { value: true, label: "Aktif" },
    { value: false, label: "Tidak Aktif" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered>
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Ubah Status Shift - {data?.name}
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="isActive" className="form-label">
              Status
            </Label>
            <Input
              id="isActive"
              name="isActive"
              type="select"
              className="form-select"
              onChange={(e) => {
                const value =
                  e.target.value === "true"
                    ? true
                    : e.target.value === "false"
                    ? false
                    : "";
                validation.setFieldValue("isActive", value);
              }}
              onBlur={validation.handleBlur}
              value={
                validation.values.isActive === ""
                  ? ""
                  : String(validation.values.isActive)
              }
              invalid={
                validation.touched.isActive && !!validation.errors.isActive
              }
            >
              <option value="">Pilih Status</option>
              {comboType.map((item, index) => (
                <option value={String(item.value)} key={index}>
                  {item.label}
                </option>
              ))}
            </Input>
            {validation.touched.isActive && validation.errors.isActive ? (
              <FormFeedback>{validation.errors.isActive}</FormFeedback>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Simpan
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

StatusModalShift.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
  getData: PropTypes.func,
  data: PropTypes.object,
};

export default StatusModalShift;
